import { render, staticRenderFns } from "./PdfList.vue?vue&type=template&id=a07312ec&"
import script from "./PdfList.vue?vue&type=script&lang=js&"
export * from "./PdfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports